export default "__VITE_ASSET__D99QihQu__"